/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssetTypeOneResponseDto,
  AssetTypeResponseDto,
  BatchImportAssetTypesRequestDto,
  CreateAssetTypeRequestDto,
  ListAssetTypesResponseDto,
  UpdateAssetTypeRequestDto,
} from '../models/index';
import {
    AssetTypeOneResponseDtoFromJSON,
    AssetTypeOneResponseDtoToJSON,
    AssetTypeResponseDtoFromJSON,
    AssetTypeResponseDtoToJSON,
    BatchImportAssetTypesRequestDtoFromJSON,
    BatchImportAssetTypesRequestDtoToJSON,
    CreateAssetTypeRequestDtoFromJSON,
    CreateAssetTypeRequestDtoToJSON,
    ListAssetTypesResponseDtoFromJSON,
    ListAssetTypesResponseDtoToJSON,
    UpdateAssetTypeRequestDtoFromJSON,
    UpdateAssetTypeRequestDtoToJSON,
} from '../models/index';

export interface AssetTypeControllerBatchImportRequest {
    batchImportAssetTypesRequestDto: BatchImportAssetTypesRequestDto;
}

export interface AssetTypeControllerCreateRequest {
    createAssetTypeRequestDto: CreateAssetTypeRequestDto;
}

export interface AssetTypeControllerDeleteRequest {
    id: string;
}

export interface AssetTypeControllerFindAllRequest {
    limit: number;
    page: number;
    q?: string;
}

export interface AssetTypeControllerFindByIdRequest {
    id: string;
}

export interface AssetTypeControllerUpdateRequest {
    id: string;
    updateAssetTypeRequestDto: UpdateAssetTypeRequestDto;
}

/**
 * 
 */
export class KnowledgeBaseAssetTypesApi extends runtime.BaseAPI {

    /**
     */
    async assetTypeControllerBatchImportRaw(requestParameters: AssetTypeControllerBatchImportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['batchImportAssetTypesRequestDto'] == null) {
            throw new runtime.RequiredError(
                'batchImportAssetTypesRequestDto',
                'Required parameter "batchImportAssetTypesRequestDto" was null or undefined when calling assetTypeControllerBatchImport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/asset-types/batch-import`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BatchImportAssetTypesRequestDtoToJSON(requestParameters['batchImportAssetTypesRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async assetTypeControllerBatchImport(requestParameters: AssetTypeControllerBatchImportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.assetTypeControllerBatchImportRaw(requestParameters, initOverrides);
    }

    /**
     */
    async assetTypeControllerCreateRaw(requestParameters: AssetTypeControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetTypeResponseDto>> {
        if (requestParameters['createAssetTypeRequestDto'] == null) {
            throw new runtime.RequiredError(
                'createAssetTypeRequestDto',
                'Required parameter "createAssetTypeRequestDto" was null or undefined when calling assetTypeControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/asset-types`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateAssetTypeRequestDtoToJSON(requestParameters['createAssetTypeRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetTypeResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async assetTypeControllerCreate(requestParameters: AssetTypeControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetTypeResponseDto> {
        const response = await this.assetTypeControllerCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async assetTypeControllerDeleteRaw(requestParameters: AssetTypeControllerDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling assetTypeControllerDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/asset-types/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async assetTypeControllerDelete(requestParameters: AssetTypeControllerDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.assetTypeControllerDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async assetTypeControllerFindAllRaw(requestParameters: AssetTypeControllerFindAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListAssetTypesResponseDto>> {
        if (requestParameters['limit'] == null) {
            throw new runtime.RequiredError(
                'limit',
                'Required parameter "limit" was null or undefined when calling assetTypeControllerFindAll().'
            );
        }

        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling assetTypeControllerFindAll().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/asset-types`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListAssetTypesResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async assetTypeControllerFindAll(requestParameters: AssetTypeControllerFindAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListAssetTypesResponseDto> {
        const response = await this.assetTypeControllerFindAllRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async assetTypeControllerFindByIdRaw(requestParameters: AssetTypeControllerFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetTypeOneResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling assetTypeControllerFindById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/asset-types/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetTypeOneResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async assetTypeControllerFindById(requestParameters: AssetTypeControllerFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetTypeOneResponseDto> {
        const response = await this.assetTypeControllerFindByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async assetTypeControllerUpdateRaw(requestParameters: AssetTypeControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetTypeResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling assetTypeControllerUpdate().'
            );
        }

        if (requestParameters['updateAssetTypeRequestDto'] == null) {
            throw new runtime.RequiredError(
                'updateAssetTypeRequestDto',
                'Required parameter "updateAssetTypeRequestDto" was null or undefined when calling assetTypeControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/asset-types/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAssetTypeRequestDtoToJSON(requestParameters['updateAssetTypeRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetTypeResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async assetTypeControllerUpdate(requestParameters: AssetTypeControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetTypeResponseDto> {
        const response = await this.assetTypeControllerUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
